<template>
    <div class="w-100">
      <ModalConfirm modalId="productModal" :text="`Are you sure to ${statusParsed} ${totalProductUpdate} products?`"
        @onClick="changeStatus({status: statusProduct, isSingle: true})" :center="true" :buttonConfig="{
            cancelText: 'Cancel',
            confirmText: `Yes, ${statusParsed}`
          }" />
      <TemplateModal :show="showModal" @handleClose="showModal=false" :center="true">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title fsize-16">Alert</p>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <label class="col-lg-12 col-form-label fw-bold text-start">
                Are you sure to {{statusParsed}} {{totalProductUpdate}} products?
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
              @click="showModal=false">Cancel</button>
            <button type="button" class="btn btn-secondary bg-white fw-bold text-danger border border-0 text-uppercase"
              @click="changeStatus({status: statusProduct})">Yes, {{statusParsed}}</button>
          </div>
        </div>
      </TemplateModal>
      <TemplateModal :show="showModalReason" @handleClose="showModalReason=false" :center="true">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title fsize-16 text-capitalize">{{buttonMessage}} Products</p>
          </div>
          <div class="modal-body pb-0">
            <div class="row mb-2">
              <label class="col-lg-12 ms-2 form-label fw-bold text-start">
                Enter {{buttonMessage}} reason
              </label>
              <div class="col-lg-12">
                <textarea class="form-control m-2" rows="5" v-model="reason" style="width: 98%;"></textarea>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center mb-3">
            <button type="button"
              class="btn btn-secondary bg-white border border-danger text-danger rounded ms-4 me-3 w-50"
              @click="showModalReason=false">Cancel</button>
            <button type="button" class="btn btn-danger text-white shadow-sm rounded w-50 me-4 text-uppercase"
              @click="changeStatus({status: statusProduct})">{{buttonMessage}}</button>
          </div>
        </div>
      </TemplateModal>
      <TableBasic :payload="payload" @onChange="changeParameter" @onLazyDropdown="handleDropdownLazy">
        <template v-slot:actions="{ data, value }">
          <div>
            <router-link
              :to="'/products/' + value.url" 
              class="btn" 
              :class="value.edit == 'disable' ? 'disabled' : ''"
            >
              <img src="@/assets/ic_edit.svg" />
            </router-link>
            <button class="btn" v-if="!data.additional_row" @click="data.additional_row = !data.additional_row">
              <font-awesome-icon icon="fa-solid fa-sort-down" class="mb-1 text-warning" />
            </button>
            <button class="btn mt-3 align-middle" v-if="data.additional_row"
              @click="data.additional_row = !data.additional_row">
              <font-awesome-icon icon="fa-solid fa-sort-up" class="mb-1 text-warning" />
            </button>
          </div>
        </template>
        <template v-slot:listVariant="{ value, data }">
          <div v-if="data.variant == 'VARIANT'">
            <p class="text-secondary">Variant</p>
            <div class="variant-container">
              <template v-for="(v, i) in value.slice(0,4)" :key="v">
                <div class="variant-item badge">
                  {{v.name}}
                  <span v-if="i === 3 && value.length > 4" class="badge counter ">
                    +{{value.length - 4}}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-slot:name="{value, data}">
          <div class="d-flex justify-content-start">
            <img :src="data.image_url" width="36" height="36" class="rounded me-3" v-if="data.image_url"
              @error="handleImageError(data)" />
            <p class="mt-3">{{value}}</p>
          </div>
        </template>
        <template v-slot:sellerName="{ data }">
          <div class="d-flex flex-column fw-bold">
            <router-link
              :to="'/users/sellers/'+data.seller_id" 
              class="text-decoration-none"
              style="color: #5e50a1"
            >
              {{data.seller ? data.seller.store_name : ""}}
            </router-link>
          </div>
        </template>
        <template v-slot:price_displayed="{ data, value }">
          <span v-if="data.is_variant">{{value}}</span>
          <div v-else class="d-flex">                
            <span
              v-if="data.price_regular > data.price_sale"
              class="text-muted text-decoration-line-through me-2"
            >
              {{ filters.rupiah(data.price_regular) }}
            </span>
            <span>
              {{ filters.rupiah(data.price_sale) }}
            </span>
          </div>
        </template>
        <template v-slot:addresses="{ data }">
          <div class="d-flex flex-column">
            <p class="text-secondary">City</p>
            <p class="fw-bold mb-0">
              <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
              {{data.seller ? data.seller.addresses[0]?.address_detail?.city : ""}}
            </p>
            <p class="fw-bold mb-0 mt-2 text-secondary">Seen {{data?.product_data?.viewed || 0}}</p>
            <p class="fw-bold mb-0 text-secondary">Sold {{data?.product_data?.sold || 0}}</p>
          </div>
        </template>
        <template v-slot:actionsSecondary="{ data, value }">
          <div class="d-flex flex-column">
            <button class="btn rounded border border-danger mt-2" data-bs-toggle="modal" data-bs-target="#productModal"
              @click="setStatusProduct(data, v.status)" style="color:#FF434F;" v-for="v in value" :key="v">
              {{v.label}}
            </button>
          </div>
        </template>
        <template v-slot:categoryProduct="{ data }">
          <div class="d-flex flex-column">
            <p class="text-secondary">Category Product</p>
            <span class="badge product">{{data.category_product.parent_category_name || "-"}}</span>
            <span class="badge product mt-3">{{data.category_product.name || "-"}}</span>
          </div>
        </template>
        <template v-slot:updatedDate="{ data }">
          <div class="d-flex flex-column">
            <p class="text-secondary">Last update</p>
            <p class="fw-bold">{{data.updated_date}}</p>
          </div>
        </template>
        <template v-slot:size="{ data,value }">
          <div class="d-flex flex-column">
            <p class="text-secondary">Dimension</p>
            <p class="fw-bold mb-0 mb-2">Size {{value[0]}} x {{value[1]}} x {{value[2]}} cm</p>
            <p class="fw-bold mb-0 mb-2">Weight {{data.weight}} gr</p>
            <p class="fw-bold mb-0 mb-2 text-secondary">Current Stock {{data.stock_current}}</p>
            <p class="fw-bold mb-0 mb-2 text-secondary">Reserve Stock {{data.reserve_stock}}</p>
          </div>
        </template>
        <template v-slot:suspendReasonButton="{ data }">
          <div class="d-flex flex-column">
            <router-link
              :to="'detail/'+data.id+'?review=true'"
              class="btn btn-danger rounded border border-danger mt-2 text-white"
              v-if="data.product_status == 'NeedReview'"
            >
              See Update
            </router-link>
            <router-link
              :to="'detail/'+data.id"
              class="btn rounded border border-0 mt-2"
              style="color:#FF434F;"
              v-if="data.product_status == 'NeedReview'"
            >
              See Original
            </router-link>
          </div>
        </template>
      </TableBasic>
    </div>
</template>
  
  <script>
    import TableBasic from "@/components/TableBasic.vue";
    import TemplateModal from "@/components/TemplateModal.vue";
    import ModalConfirm from "@/components/ModalConfirm.vue";
    import defaultImage from "@/assets/defaultImage.png"
  
    // import vSelect                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   from "vue-select";
    import 'vue-select/dist/vue-select.css';
    import lodash from 'lodash'
  
    export default {
      components: {
        TableBasic,
        TemplateModal,
        ModalConfirm
        // vSelect
      },
      props: {
        productStatus : {
          type: String,
          default : 'LiveInStock'
        }
      },
      data() {
        return {
          isUrlReplaced: false,
          payload: {
            header: [{
                key: "id",
                label: "PRODUCT ID",
                link: "/products/detail"
              },
              {
                key: "variant",
                label: "TYPE",
                sort: true,
                sort_key: "is_variant"
              },
              {
                key: "name",
                label: "PRODUCT NAME",
              },
              {
                key: "sellerName",
                label: "SELLER",
              },
              {
                key: "price_displayed",
                label: "PRICE",
                sort_key: 'price_sale',
                sort: true
              },
              {
                key: "created_date",
                label: "CREATED DATE",
                sort_key: 'created_date',
                sort: true
              },
              {
                key: "actions",
                label: "ACTIONS",
              },
            ],
            second_header: [{
                key: "listVariant",
                label: "Variant",
              },
              {
                key: "",
                label: ""
              },
              {
                key: "size",
                label: "Dimension",
              },
              {
                key: "addresses",
                label: "City",
              },
              {
                key: "categoryProduct",
                label: "Category Product",
              },
              {
                key: "updatedDate",
                label: "Last Update",
              },
              {
                key: "actionsSecondary",
                label: "Actions",
              },
            ],
            value: [],
            checkbox: true,
            filter_custom: true,
            filter: false,
            filterList: [{
                key: "category_product_id",
                label: "by Category Product",
                type: "select"
              },
              {
                key: "category_promo_id",
                label: "by Category Promo",
                type: "select"
              },
              {
                key: "price_regular",
                label: "by Product Price",
                type: "number"
              },
              {
                key: "price_sale",
                label: "by Discount Price",
                type: "number"
              }, {
                key: "seller_name",
                label: "by Seller",
                type: "text"
              }
            ],
            listFilterValue: [],
            listFilterValueSecond: [],
            search: true,
            searchPlaceholder: 'Product Name, Variant, Product ID',
            searchContainerStyle: {
              maxWidth: '235px'
            },
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            totalItems: 0,
            pickItems: [],
            buttonRow: [{
              label: "Expand",
              status: "expand"
            }],
            searchInput: ""
          },
          status: "",
          statusProduct: "",
          selected: [],
          searchInput: "",
          filterValue: "",
          filterValueSecond: "",
          filterKey: "",
          pickItems: [],
          totalProductUpdate: 0,
          selectedProduct: {},
          showModal: false,
          showModalReason: false,
          buttonMessage: "",
          modalElement: [],
          statusBulk: "",
          reason: ""
        };
      },
      watch: {
        requestPayload: {
          handler: function (newVal, oldVal) {
            const isChange = JSON.stringify(newVal) !== JSON.stringify(oldVal)
            console.log({newVal, oldVal, isChange})
            if(isChange) {
              this.getData()
            }
          },
          deep: true,
        },
      },
      computed: {
        requestPayload(){
          return {
            perPage: this.payload.perPage,
            currentPage: this.payload.currentPage,
            sortType: this.payload.sortType,
            sortBy: this.payload.sortBy,
            // prevent undefined value
            filterValue: this.filterValue || "",
            filterValueSecond: this.filterValueSecond || "",
            searchInput: this.searchInput || "",
          }
        },
        statusParsed() {
          if (this.statusProduct == 'Archive') return 'archive'
          if (this.statusProduct == 'Suspended') return 'suspend'
          if (this.statusProduct == 'Unsuspend') return 'resuspend'
          if (this.statusProduct == 'Published') return 'live'
  
          return this.statusProduct
        },
      },
      methods: {
        handleStatusUrl({status, data}){
          if(status == "Published" && data?.stock_current <= 0) return "LiveOutOfStock"
          if(status == "Published") return "LiveInStock"
          if(status == "Unsuspend") return "Suspended"
          return status        
        },
        handleImageError(data) {
          let tempValue = [...this?.payload?.value]
          const indexData = this?.payload?.value?.findIndex(find => find.id === data.id)
          tempValue[indexData] = {
            ...tempValue[indexData],
            image_url: defaultImage
          }
          this.payload.value = tempValue
        },
        changeParameter: lodash.debounce(function (value) {
          console.log("VALUE")
          console.log(value)
          this.payload.perPage = value.per_page
          this.payload.currentPage = value.current_page
           
          this.payload.sortType = value.sort_type
          this.payload.sortBy = value.sort_by
          this.filterKey = value.filter ? value.filter.key : ""
          this.filterValue = value.filter_value
          this.filterValueSecond = value.filter_value_second
          this.searchInput = value.search
          this.payload.totalItems = value.pick_items ? value.pick_items.length : this.payload.totalItems
          this.totalProductUpdate = value.pick_items ? value.pick_items.length : 0
          this.pickItems = value.pick_items
          this.statusBulk = value.status ? value.status : ""
          if (value.filter) {
            if (value.filter.key == "category_product_id") {
              // the conditonal for filter get categories and promo
              // make it hit only if filterValue is empty.
              // if filterValue is filled, bypass this functions,
              // this functions will be handled on handleDropdownLazy next.
              if (!this.filterValue) this.getCategoryProduct()
              if (this.filterValue && !this.filterValueSecond) {
                this.getCategoryProductChild({
                  id: this.filterValue
                })
              }
            }
            if (value.filter.key == "category_promo_id") {
              if (!this.filterValue) this.getCategoryPromo()
            }
          }
          // handle open modal
          if (this.statusBulk != "" && this.statusBulk != "expand") {
            this.showModal = true
            this.statusProduct = this.statusBulk
  
            this.buttonMessage = this.statusBulk == "Unsuspend" ? "resuspend" : "suspend"
          }
          // handle expand
          if (this.statusBulk == "expand") { 
            this.payload.value.map(x => {
              const found = this.pickItems.find(item => x.id == item)
              x.additional_row = found ? true : false
            })
          }
        }, 500),
        handleDropdownLazy({
          type,
          value
        }) {
          /**
           * category_parent
           * category_child
           */
          // console.log({type, value})
  
          if (type === "category_parent") {
            this.getCategoryProduct({
              name: value
            })
            // reset filtervaluesecond, when fetch new cat parent
            // in the TableBasic Component, also handle to reset display text input
            if(!value){
              this.filterValueSecond = ""
            }
          }
  
          if (type === "category_child" && this.filterValue !== "") {
            this.getCategoryProductChild({
              id: this.filterValue,
              name: value
            })
          }
  
          if (type === "category_promo") {
            this.getCategoryPromo({
              name: value
            })
          }
        },
        async getData() {
          let payload = {
            page: this.payload.currentPage,
            size: this.payload.perPage,
            status: this.status
          }
          try {
            if (this.sortBy != "") {
              payload.sort_by = this.payload.sortBy
              payload.sort_type = this.payload.sortType
            }
  
            if (this.searchInput != "") {
              payload.keyword = this.searchInput
            }
  
            if (this.filterKey != "" && this.filterValue != "") {
              switch (this.filterKey) {
                case this.filterKey = "category_product_id":
                  payload.category_product_id = this.filterValueSecond || this.filterValue
                  break;
                case this.filterKey = "category_promo_id":
                  payload.category_promo_id = this.filterValue
                  break;
                case this.filterKey = "price_sale":
                  payload.price_sale_min = this.filterValue
                  payload.price_sale_max = this.filterValueSecond
                  break;
                case this.filterKey = "price_regular":
                  payload.price_regular_min = this.filterValue
                  payload.price_regular_max = this.filterValueSecond
                  break;
                case this.filterKey = "seller_name":
                  payload.seller_name = this.filterValue
                  break;
                default:
                  break;
              }
            }
  
            const indexReason = this.payload.header.findIndex(x => x.key == "suspend_reason")
            if (indexReason > 0) {
              const indexReasonSecond = this.payload.second_header.findIndex(x => x.key == "suspendReasonButton")
              this.payload.header.splice(indexReason, 1)
              this.payload.second_header.splice(indexReasonSecond, 1)
            }
  
            if (this.status == "Suspended" || this.status == "NeedReview") {
              this.payload.header.splice(this.payload.header.length - 1, 0, {
                key: "suspend_reason",
                label: "SUSPEND REASON",
                style: "width:20%;"
              })
  
              this.payload.second_header.splice(this.payload.header.length - 2, 0, {
                key: "suspendReasonButton",
                label: "",
              })
            }
  
            const response = await this.$store.dispatch("product/getAllProduct", payload)
            const data = this.$store.getters["product/productItems"]
            // make sure additional_row value local is not changed
            let temp = data.map(x => {
              let obj = {
                ...x
              }
              const found = this.payload.value.find(findVal => findVal.id === x.id)
              if (found) {
                obj.additional_row = found.additional_row
              }
              return obj
            })
  
            this.payload.value = temp
  
            this.payload.totalRows = response.count
            // if product status All, dont update buttonRow (display action bulk)
            if(this.status != "All"){
              if (data?.length > 0 && this.payload.buttonRow.length == 1) {
                this.payload.buttonRow.push(...data[0].actionsSecondary)
              } else if (data) {
                this.payload.buttonRow = this.payload.buttonRow.slice(0, 1)
                data[0]?.actionsSecondary && this.payload.buttonRow.push(...data[0].actionsSecondary)
              }
            }

            // get count value to parent
            this.$emit("getCount", response.count)
          } catch (error) {
            console.log("ERROR : ", error)
            this.$swal({
              title: error.response?.data?.errorMessage || error.message,
              icon: "warning",
              timer: 2000,
            })
          }
        },
        async getCategoryPromo(data) {
          let payload = {
            page: 1,
            size: 10,
          }
          if (data?.name) payload.name = data?.name
          const response = await this.$store.dispatch("product/getAllCategoryPromo", payload)
          this.payload.listFilterValue = response.items
  
        },
        async getCategoryProduct(data) {
          let payload = {
            page: 1,
            size: 10,
            level: 1
          }
          if (data?.name) payload.name = data?.name
          const response = await this.$store.dispatch("product/getAllCategoryProduct", payload)
          this.payload.listFilterValue = response.items
        },
        async getCategoryProductChild(data) {
          let payload = {
            page: 1,
            size: 10,
            level: 2,
          }
          if (data?.name) payload.name = data?.name
          await this.$store.dispatch("product/getAllCategoryProduct", payload)
  
          let childFunct = this.$store.getters['product/childProductItems']
          let childs = childFunct(data?.id)
  
          this.payload.listFilterValueSecond = childs
        },
        setStatusProduct(data, status) {
          this.selectedProduct = data
          this.statusProduct = status
          this.totalProductUpdate = 1
          this.buttonMessage = status == "Unsuspend" ? "resuspend" : "suspend"
        },
        async changeStatus({status, isSingle}) {
          if(isSingle) this.isSingle = true
          if ((status == "Suspended" || status == "Unsuspend") && !this.showModalReason) {
            this.showModalReason = true
            this.showModal = false
            return
          }
          try {
            this.$store.dispatch('setLoadingGlobal', true)
            let payload = {
              status: status,
              reason: this.reason
            }
            this.showModalReason = false
            this.showModal = false

            payload.status = status == "Unsuspend" ? "Suspended" : status
            if (this.pickItems.length > 0 && !this.isSingle) {
              payload.product_ids = this.pickItems
              if(this.status == "NeedReview"){
                await this.$store.dispatch("product/updateStatusOnReviewBulkProduct", payload)
              }else{
                await this.$store.dispatch("product/updateStatusBulkProduct", payload)
              }

              
              this.payload.totalItems = 0
              this.payload.pickItems = []
              this.pickItems = []
              setTimeout(() => {
                this.reason = ""
                this.status = this.handleStatusUrl({status})
                this.$router.push("/products/all-product?status=" + this.status)
              }, 500);
            } else {
              payload.id = this.selectedProduct?.id
              if(this.status == "NeedReview"){
                await this.$store.dispatch("product/updateStatusOnReviewProduct", payload)
              }else{
                await this.$store.dispatch("product/updateStatusProduct", payload)
              }

              this.payload.totalItems = 0
              this.payload.pickItems = []
              this.pickItems = []
              setTimeout(() => {
                this.reason = ""
                this.showMessage = false
                this.status = this.handleStatusUrl({status, data : this.selectedProduct})
                this.$router.push("/products/all-product?status=" + this.status)
              }, 500);
            }
          } catch (error) {
            this.$swal({
              title: error.response?.data?.errorMessage || error.message,
              icon: "warning",
              timer: 2000,
            })
          }finally{
            this.isSingle = false
            this.$store.dispatch('setLoadingGlobal', false)
          }
        },
      },
      async mounted() {
        await this.getData()
        this.getCategoryProduct()
      },
      created() {
        this.status = this.productStatus
      }
    };
  </script>
  
  <style lang="scss" scoped>
    .modal-mask {
      position: fixed;
      z-index: 1100;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, .5);
      display: table;
      transition: opacity .3s ease;
    }
  
    .modal-wrapper {
      display: table-cell;
      vertical-align: middle;
    }
  
    .variant-container {
      display: flex;
      flex-wrap: wrap;
      column-gap: 10px;
      row-gap: 8px;
      max-width: 280px;
  
      .variant-item {
        position: relative;
        align-self: center;
        width: calc(50% - 5px);
      }
  
  
      .counter {
        position: absolute;
        bottom: 0;
        right: -40px;
      }
    }

    .badge {
        white-space: normal;
        color: #5E50A1;
        background-color: #F3F2F8;
        border-radius: 15px;
        font-size: 12px;
        line-height: 1.5;
        border-radius: 13px;

        &.product {
          width: fit-content;
          padding: 0.35rem 1.25rem;
        }
      }
  </style>